import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const ContactUs = () => {
  return (
    <div className="container py-5">
      <h2 className="text-center mb-4">Contact Us</h2>

      <div className="row mb-5">
        <div className="col-md-6">
          <div className="card shadow p-4">
            <h5 className="mb-3">📍 Address</h5>
            <p>45a Meenakshipuram 4th Street Thoothukudi</p>

            <h5 className="mt-4 mb-3">📞 Phone</h5>
            <p>9787061406</p>

            <h5 className="mt-4 mb-3">📧 Email</h5>
            <p>pandasquare.in</p>

            <h5 className="mt-4 mb-3">🕒 Business Hours</h5>
            <p>Mon - Fri: 9:00 AM – 6:00 PM</p>
          </div>
        </div>

        <div className="col-md-6">
          <div className="ratio ratio-4x3 shadow">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3942.7929642866034!2d78.13841897582596!3d8.805511792445564!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b03ef8ea53d35c5%3A0xe136690493060654!2sPMP%20LADIES%20TAILOR!5e0!3m2!1sen!2sin!4v1760432475194!5m2!1sen!2sin"
              title="Google Map"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;